import { Typography } from '@mui/material';
import React from 'react';

const SearchFilterClearButton: React.FC<{
  areFilterSelected: boolean;
  handleFilterClear: () => void;
}> = ({ areFilterSelected, handleFilterClear }) => {
  return (
    <Typography
      onClick={handleFilterClear}
      variant="body2"
      sx={{
        visibility: areFilterSelected ? 'visible' : 'hidden',
        position: 'relative',
        cursor: 'pointer',
        fontWeight: '500',
        pl: 1,
        '&:hover': {
          fontWeight: '700'
        }
      }}
    >
      Clear Filters
    </Typography>
  );
};

export default SearchFilterClearButton;
